import React from 'react';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { SmartLink } from '../SmartLink/SmartLink';
import './ArticlePreview.scss';
import { graphql, useStaticQuery } from 'gatsby';

export interface ArticlePreviewProps {
    id?: string;
    title: string;
    link: string;
    categoryName: string;
    categoryLink: string;
    summary: string;
    image?: IGatsbyImageData;
    imgAlt?: string;
    theme?: `light` | `dark`;
    size: `lg` | `md` | `sm`;
}

export const ArticlePreview = (props: ArticlePreviewProps) => {
    const { mediaHeroImage: placeholderImg } = useStaticQuery(graphql`
        query {
            mediaHeroImage(name: { eq: "article-image-placeholder" }) {
                field_media_image {
                    alt
                }
                relationships {
                    field_media_image {
                        localFile {
                            childImageSharp {
                                ...ImageConstrainedOneHalfSettings
                            }
                        }
                    }
                }
            }
        }
    `);

    let img = props.image;

    if (!img) {
        img = getImage(
            placeholderImg.relationships?.field_media_image?.localFile
        );
    }

    return (
        <section
            className={`c--article-preview ${props.theme ?? `light`} ${
                props.size
            }`}
        >
            <SmartLink
                href={props.link}
                title={props.title}
                className={`context-link`}
                aria-labelledby={`${props.id}-context`}
            >
                <div id={`${props.id}-context`} className="col">
                    {props.categoryName && (
                        <span className="eyebrow">{props.categoryName}</span>
                    )}
                    {props.title && (
                        <div className="text">
                            <h3>{props.title}</h3>
                            {props.size !== `sm` && (
                                <div className="summary">
                                    <p>{props.summary}</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </SmartLink>
            <SmartLink
                href={props.link}
                className={`image-link`}
                title={props.title}
                aria-label={`${props.title} | ${props.imgAlt || ``}`}
            >
                <GatsbyImage image={img} alt={props.imgAlt || ``} />
            </SmartLink>
        </section>
    );
};
